import { tv } from "@ui/lib/tv";
import { composeRenderProps } from "@ui/primitives/shared";
import { ToggleButtonGroup, type ToggleButtonGroupProps } from "@ui/primitives/ToggleButtonGroup";
import type { ReactNode } from "react";

const familyToggleGroup = tv({
  // Five columns rather than a scrolling row: an intrinsically-sized row's
  // min-content (six people ≈ 600px) would set the width of the whole modal
  // form column — Silk's Scroll.Content is a flex item with the default
  // `min-width: auto` — clipping every other field. `w-full min-w-0` caps it;
  // the fixed track count means tiles shrink to always fit five across.
  base: "grid w-full min-w-0 grid-cols-5 gap-x-1 gap-y-4 p-1 md:gap-x-2",
});

export interface FamilyToggleGroupProps extends Omit<ToggleButtonGroupProps, "children" | "selectionMode"> {
  children: ReactNode;
}

export function FamilyToggleGroup({ children, ...props }: FamilyToggleGroupProps) {
  return (
    <ToggleButtonGroup
      {...props}
      className={composeRenderProps(props.className, (className) => familyToggleGroup({ className }))}
      selectionMode="multiple"
    >
      {children}
    </ToggleButtonGroup>
  );
}
